import React, { useState } from 'react';
import { useScoreboard } from './context/ScoreboardContext';

const Settings = () => {
  const {
    showSettings,
    setShowSettings,
    backgroundColor,
    setBackgroundColor,
    defaultGameDuration,
    setDefaultGameDuration,
    defaultOvertime,
    setDefaultOvertime,
    defaultBreakDuration,
    setDefaultBreakDuration,
    overtimeBreak1Duration,
    setOvertimeBreak1Duration,
    overtimeBreak2Duration,
    setOvertimeBreak2Duration,
    autoBreakEnabled,
    setAutoBreakEnabled,
    carouselImages,
    setCarouselImages,
    isBuzzerEnabled,
    setIsBuzzerEnabled,
    buzzerVolume,
    setBuzzerVolume,
    isEntertainmentEnabled,
    activeLicense,
    activateLicense,
    deactivateLicense,
    showTeamInferiority,
    setShowTeamInferiority
  } = useScoreboard();

  const [activeTab, setActiveTab] = useState('general');
  const [durationInput, setDurationInput] = useState(defaultGameDuration);
  const [overtimeInput, setOvertimeInput] = useState(defaultOvertime);
  const [breakDurationInput, setBreakDurationInput] = useState(defaultBreakDuration);
  const [overtimeBreak1Input, setOvertimeBreak1Input] = useState(overtimeBreak1Duration);
  const [overtimeBreak2Input, setOvertimeBreak2Input] = useState(overtimeBreak2Duration);
  const [nameInput, setNameInput] = useState('');
  const [keyInput, setKeyInput] = useState('');

  if (!showSettings) return null;

  const handleDurationChange = (e) => {
    const value = e.target.value;
    if (value.match(/^\d{0,2}:\d{0,2}$/)) {
      setDurationInput(value);
    }
  };

  const handleDurationBlur = () => {
    const [minutes, seconds] = durationInput.split(':').map(Number);
    if (!isNaN(minutes) && !isNaN(seconds) && seconds < 60) {
      const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setDurationInput(formattedDuration);
      setDefaultGameDuration(formattedDuration);
    } else {
      setDurationInput(defaultGameDuration);
    }
  };

  const handleOvertimeChange = (e) => {
    const value = e.target.value;
    if (value.match(/^\d{0,2}:\d{0,2}$/)) {
      setOvertimeInput(value);
    }
  };

  const handleOvertimeBlur = () => {
    const [minutes, seconds] = overtimeInput.split(':').map(Number);
    if (!isNaN(minutes) && !isNaN(seconds) && seconds < 60) {
      const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setOvertimeInput(formattedDuration);
      setDefaultOvertime(formattedDuration);
    } else {
      setOvertimeInput(defaultOvertime);
    }
  };

  const handleBreakDurationChange = (e) => {
    const value = e.target.value;
    if (value.match(/^\d{0,2}:\d{0,2}$/)) {
      setBreakDurationInput(value);
    }
  };

  const handleBreakDurationBlur = () => {
    const [minutes, seconds] = breakDurationInput.split(':').map(Number);
    if (!isNaN(minutes) && !isNaN(seconds) && seconds < 60) {
      const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setBreakDurationInput(formattedDuration);
      setDefaultBreakDuration(formattedDuration);
    } else {
      setBreakDurationInput(defaultBreakDuration);
    }
  };

  const handleOvertimeBreak1Change = (e) => {
    const value = e.target.value;
    if (value.match(/^\d{0,2}:\d{0,2}$/)) {
      setOvertimeBreak1Input(value);
    }
  };

  const handleOvertimeBreak1Blur = () => {
    const [minutes, seconds] = overtimeBreak1Input.split(':').map(Number);
    if (!isNaN(minutes) && !isNaN(seconds) && seconds < 60) {
      const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setOvertimeBreak1Input(formattedDuration);
      setOvertimeBreak1Duration(formattedDuration);
    } else {
      setOvertimeBreak1Input(overtimeBreak1Duration);
    }
  };

  const handleOvertimeBreak2Change = (e) => {
    const value = e.target.value;
    if (value.match(/^\d{0,2}:\d{0,2}$/)) {
      setOvertimeBreak2Input(value);
    }
  };

  const handleOvertimeBreak2Blur = () => {
    const [minutes, seconds] = overtimeBreak2Input.split(':').map(Number);
    if (!isNaN(minutes) && !isNaN(seconds) && seconds < 60) {
      const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setOvertimeBreak2Input(formattedDuration);
      setOvertimeBreak2Duration(formattedDuration);
    } else {
      setOvertimeBreak2Input(overtimeBreak2Duration);
    }
  };

  const compressImage = (base64String) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX_WIDTH = 800;
        const MAX_HEIGHT = 600;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = 'transparent';
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/png', 1.0));
      };
      img.src = base64String;
    });
  };

  const handleImageUpload = (event, index) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const compressedImage = await compressImage(e.target.result);
        const newImages = [...carouselImages];
        newImages[index] = compressedImage;
        setCarouselImages(newImages);
      } catch (error) {
        console.error('Error processing image:', error);
        alert('Error processing image');
      }
    };
    reader.readAsDataURL(file);
  };

  const handleImageRemove = (index) => {
    const newImages = [...carouselImages];
    newImages.splice(index, 1);
    setCarouselImages(newImages);
  };

  const handleActivate = () => {
    const licenseInput = `${nameInput}:${keyInput}`;
    const success = activateLicense(licenseInput);
    if (!success) {
      alert('Invalid license key');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto m-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold">Settings</h2>
          <button 
            onClick={() => setShowSettings(false)}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ✕
          </button>
        </div>
        
        {/* Tab Navigation */}
        <div className="flex border-b border-gray-200 mb-6">
          <button
            onClick={() => setActiveTab('general')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'general'
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            General Settings
          </button>
          <button
            onClick={() => setActiveTab('license')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'license'
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Media License
          </button>
          <button
            onClick={() => setActiveTab('beta')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'beta'
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Beta Features
          </button>
        </div>
        
        <div className="space-y-8">
          {/* General Settings Tab */}
          {activeTab === 'general' && (
            <>
              {/* Game Timer Settings */}
              <div>
                <h3 className="text-xl font-semibold mb-4">Game Timer</h3>
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="flex items-center">
                    <label className="font-medium whitespace-nowrap w-36">Default Period:</label>
                    <input
                      type="text"
                      value={durationInput}
                      onChange={handleDurationChange}
                      onBlur={handleDurationBlur}
                      placeholder="MM:SS"
                      className="px-4 py-2 border rounded w-24 text-center text-lg"
                    />
                  </div>
                  <div className="flex items-center">
                    <label className="font-medium whitespace-nowrap w-36">Overtime Period:</label>
                    <input
                      type="text"
                      value={overtimeInput}
                      onChange={handleOvertimeChange}
                      onBlur={handleOvertimeBlur}
                      placeholder="MM:SS"
                      className="px-4 py-2 border rounded w-24 text-center text-lg"
                    />
                  </div>
                  <div className="flex items-center">
                    <label className="font-medium whitespace-nowrap w-36">Break (P1→P2):</label>
                    <input
                      type="text"
                      value={breakDurationInput}
                      onChange={handleBreakDurationChange}
                      onBlur={handleBreakDurationBlur}
                      placeholder="MM:SS"
                      className="px-4 py-2 border rounded w-24 text-center text-lg"
                    />
                  </div>
                  <div className="flex items-center">
                    <label className="font-medium whitespace-nowrap w-36">Break (P2→P3):</label>
                    <input
                      type="text"
                      value={overtimeBreak1Input}
                      onChange={handleOvertimeBreak1Change}
                      onBlur={handleOvertimeBreak1Blur}
                      placeholder="MM:SS"
                      className="px-4 py-2 border rounded w-24 text-center text-lg"
                    />
                  </div>
                  <div className="flex items-center">
                    <label className="font-medium whitespace-nowrap w-36">Break (P3→P4):</label>
                    <input
                      type="text"
                      value={overtimeBreak2Input}
                      onChange={handleOvertimeBreak2Change}
                      onBlur={handleOvertimeBreak2Blur}
                      placeholder="MM:SS"
                      className="px-4 py-2 border rounded w-24 text-center text-lg"
                    />
                  </div>
                </div>
              </div>

              {/* Background Color Settings */}
              <div>
                <h3 className="text-xl font-semibold mb-4">Background Color</h3>
                <div className="flex items-center">
                  <label className="font-medium whitespace-nowrap w-36">Brand Color:</label>
                  <input
                    type="color"
                    value={backgroundColor}
                    onChange={(e) => setBackgroundColor(e.target.value)}
                    className="w-20 h-10"
                  />
                </div>
              </div>

              {/* Sound Settings */}
              <div>
                <h3 className="text-xl font-semibold mb-4">Sound Settings</h3>
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="flex items-center">
                    <label className="font-medium whitespace-nowrap w-28 mr-4">Buzzer Sound:</label>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={isBuzzerEnabled}
                        onChange={(e) => setIsBuzzerEnabled(e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      <span className="ml-3 text-sm font-medium text-gray-900">
                        {isBuzzerEnabled ? 'Enabled' : 'Disabled'}
                      </span>
                    </label>
                  </div>
                  
                  {isBuzzerEnabled && (
                    <div className="flex items-center">
                      <label className="font-medium whitespace-nowrap w-28 mr-4">Buzzer Volume:</label>
                      <div className="flex items-center space-x-3">
                        <input
                          type="range"
                          min="0"
                          max="2"
                          step="0.1"
                          value={buzzerVolume}
                          onChange={(e) => setBuzzerVolume(parseFloat(e.target.value))}
                          className="w-32 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
                        />
                        <span className="text-sm font-medium text-gray-700 w-12">
                          {Math.round(buzzerVolume * 100)}%
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Image Carousel Settings */}
              <div>
                <h3 className="text-xl font-semibold mb-4">Sponsor images</h3>
                <div className="space-y-4">
                  <p className="text-sm text-gray-600">Upload up to 6 images to be shown in the carousel of the scoreboard.</p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {[...Array(6)].map((_, index) => {
                      const image = carouselImages[index];
                      return (
                        <div key={index} className="border rounded-lg p-4 space-y-2">
                          <div className="flex items-center justify-between">
                            <span className="text-sm font-medium">Image Slot {index + 1}</span>
                            {image && (
                              <button
                                onClick={() => handleImageRemove(index)}
                                className="text-red-600 hover:text-red-700 text-sm"
                              >
                                Remove
                              </button>
                            )}
                          </div>

                          {image ? (
                            <div className="relative w-full h-32">
                              <img
                                src={image}
                                alt={`Carousel ${index + 1}`}
                                className="w-full h-full object-cover rounded-lg"
                              />
                            </div>
                          ) : (
                            <div className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-4 h-32">
                              <label className="cursor-pointer text-center">
                                <span className="text-sm text-gray-500">Click to upload image</span>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="hidden"
                                  onChange={(e) => {
                                    if (e.target.files?.[0]) {
                                      handleImageUpload(e, index);
                                    }
                                  }}
                                />
                              </label>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Media License Tab */}
          {activeTab === 'license' && (
            <div>
              <h3 className="text-xl font-semibold mb-4">Entertainment License</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  License Status
                </label>
                <div className={`text-sm ${isEntertainmentEnabled ? 'text-green-600' : 'text-red-600'}`}>
                  {isEntertainmentEnabled ? '✓ Active' : '✗ Inactive'}
                </div>
                {activeLicense && (
                  <div className="text-sm text-gray-600 mt-1">
                    Licensed to: {activeLicense.split(':')[0]}
                  </div>
                )}
              </div>

              <div className="space-y-3">
                {!isEntertainmentEnabled && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        License Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter license name"
                        className="border rounded px-2 py-1 text-sm w-64"
                        value={nameInput}
                        onChange={(e) => setNameInput(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        License Key
                      </label>
                      <input
                        type="text"
                        placeholder="Enter license key"
                        className="border rounded px-2 py-1 text-sm w-64"
                        value={keyInput}
                        onChange={(e) => setKeyInput(e.target.value)}
                      />
                    </div>

                    <div className="pt-2">
                      <button
                        onClick={handleActivate}
                        className="bg-blue-500 text-white px-4 py-1 rounded text-sm hover:bg-blue-600"
                      >
                        Activate License
                      </button>
                    </div>
                  </>
                )}
                
                {isEntertainmentEnabled && (
                  <div className="pt-2">
                    <button
                      onClick={deactivateLicense}
                      className="bg-red-500 text-white px-4 py-1 rounded text-sm hover:bg-red-600"
                    >
                      Deactivate License
                    </button>
                  </div>
                )}
                </div>
              </div>
            </div>
          )}

          {/* Beta Features Tab */}
          {activeTab === 'beta' && (
            <div>
              <h3 className="text-xl font-semibold mb-4">Beta Features</h3>
              <p className="text-sm text-gray-600 mb-6">These features are experimental and may change in future updates.</p>
              
              <div className="space-y-6">
                {/* Auto Break Toggle */}
                <div className="flex items-center justify-between p-4 border rounded-lg">
                  <div>
                    <h4 className="font-medium text-gray-900">Auto Break</h4>
                    <p className="text-sm text-gray-600 mt-1">Automatically start break timer when a period ends</p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={autoBreakEnabled}
                      onChange={(e) => setAutoBreakEnabled(e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    <span className="ml-3 text-sm font-medium text-gray-900">
                      {autoBreakEnabled ? 'Enabled' : 'Disabled'}
                    </span>
                  </label>
                </div>

                {/* Team Inferiority Display Toggle */}
                <div className="flex items-center justify-between p-4 border rounded-lg">
                  <div>
                    <h4 className="font-medium text-gray-900">Team Inferiority Display</h4>
                    <p className="text-sm text-gray-600 mt-1">Show cumulative penalty time for teams in control view</p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={showTeamInferiority}
                      onChange={(e) => setShowTeamInferiority(e.target.checked)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    <span className="ml-3 text-sm font-medium text-gray-900">
                      {showTeamInferiority ? 'Enabled' : 'Disabled'}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
